<template>
	<b-row>
		<b-col md="12">
			<b-card>
				<template v-slot:header>
					<b-row>
						<b-col md="6">
							<strong>Información de la Cuenta</strong>
						</b-col>
						<b-col md="6" class="d-flex justify-content-end">
							<div v-if="loading" class="ml-2">
								<b-spinner variant="primary" label="Spinning" small></b-spinner>
							</div>
						</b-col>
					</b-row>
				</template>
				<b-card-body>
					<b-row>
						<b-col md="4" lg="3">
							<h6><span class="text-info">Número de Cuenta: </span> {{accountSelected.accountNumber}}
							</h6>
						</b-col>

						<b-col md="4" lg="3">
							<h6><span class="text-info">Nombre de la Cuenta:</span> {{accountSelected.accountName}}
							</h6>
						</b-col>

						<b-col md="4" lg="3">
							<h6><span class="text-info">Alias de la Cuenta:</span> {{accountSelected.alias}}</h6>
						</b-col>

						<b-col md="4" lg="3" v-if="accountSelected.email">
							<h6><span class="text-info">Correo Electrónico:</span> {{accountSelected.email}}</h6>
						</b-col>

						<b-col md="4" lg="3" v-if="accountSelected.phone">
							<h6><span class="text-info">Teléfono:</span> {{accountSelected.phone}}</h6>
						</b-col>

						<b-col md="4" lg="3" v-if="accountSelected.ClientAdvisor">
							<h6><span class="text-info">Ejecutivo de Cuenta:</span>
								{{accountSelected.ClientAdvisor.name}}</h6>
						</b-col>

						<b-col md="4" lg="3" v-if="accountSelected.CustomerCostCenter">
							<h6><span class="text-info">Centro de Costo Cliente:</span>
								{{accountSelected.CustomerCostCenter.code}}</h6>
						</b-col>

						<b-col md="4" lg="3" v-if="accountSelected.requieredAuth">
							<h6><span class="text-info">Requiere Autorizadores:</span> Sí</h6>
						</b-col>

						<b-col md="4" lg="3" v-if="accountSelected.AuthUser_1">
							<h6><span class="text-info">Autorizador #1:</span>
								{{accountSelected.AuthUser_1.firstName}} {{accountSelected.AuthUser_1.lastName}}
							</h6>
						</b-col>

						<b-col md="4" lg="3" v-if="accountSelected.AuthUser_2">
							<h6><span class="text-info">Autorizador #2:</span>
								{{accountSelected.AuthUser_2.firstName}} {{accountSelected.AuthUser_2.lastName}}
							</h6>
						</b-col>

						<b-col md="4" lg="3" v-if="accountSelected.AuthUser_3">
							<h6><span class="text-info">Autorizador #3:</span>
								{{accountSelected.AuthUser_3.firstName}} {{accountSelected.AuthUser_3.lastName}}
							</h6>
						</b-col>

						<b-col md="4" lg="3" v-if="accountSelected.AuthQuoteUser">
							<h6><span class="text-info">Autorizador de Cotizaciones:</span>
								{{accountSelected.AuthQuoteUser.firstName}} {{accountSelected.AuthQuoteUser.lastName}}
							</h6>
						</b-col>
					</b-row>
				</b-card-body>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
	export default {
		name: "AccountDetailComponent",
		props: ['accountSelected', 'loading']
	}
</script>

<style scoped>

</style>
